import application from 'application/application';
import template from './subpoena.template.html';
import controller from './subpoena.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider.state('root.default.subpoena', {
			url:
				'/intimacoes?paginaAtual&palavraChave&lido&registrosPorPagina&diary&note&dataInicio&dataFim',
			views: {
				'default@root.default': {
					templateUrl: template,
					controller: controller
				}
			},
			data: {
				documentTitle: 'Intimações',
				displayName: 'Intimações'
			}
		});
	}
]);
